import { useEffect } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import {
  resolveLandingPagePath,
  shouldSkipLandingPageRedirect,
} from '@/hooks/landingPageRedirect';
import useAppointmentStore from '@/store/AppointmentStore';
import useSessionStore from '@/store/SessionStore';

const useLandingPageRedirection = () => {
  const { selectedDestination, appointmentId, confirmedAppointment } =
    useAppointmentStore();
  const sessionSource = useSessionStore((state) => state.sessionSource);
  const navigate = useNavigate();
  const isEmailMatch = useMatch('/email/*');
  const isEmailInquiryMatch = useMatch('/email-inquiry/*');
  const isEmailConfirmationMatch = useMatch('/email-confirmation/*');

  const isEmailFlow =
    isEmailMatch || isEmailInquiryMatch || isEmailConfirmationMatch;
  const navigateTo = resolveLandingPagePath(Boolean(isEmailFlow));

  useEffect(() => {
    if (
      shouldSkipLandingPageRedirect({
        selectedDestination,
        appointmentId,
        confirmedAppointment,
        sessionSource,
      })
    ) {
      return;
    }

    navigate(navigateTo);
  }, [
    appointmentId,
    confirmedAppointment,
    selectedDestination,
    sessionSource,
    navigate,
    navigateTo,
  ]);

  return navigateTo;
};

export default useLandingPageRedirection;
